import { render, staticRenderFns } from "./comNews.vue?vue&type=template&id=14ae29fb&scoped=true"
import script from "./comNews.vue?vue&type=script&lang=js"
export * from "./comNews.vue?vue&type=script&lang=js"
import style0 from "./comNews.vue?vue&type=style&index=0&id=14ae29fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ae29fb",
  null
  
)

export default component.exports